var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegionalScreenshot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.778,
    y1: 0.096,
    x2: 0.182,
    y2: 0.894,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ad2df4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc26fb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Regional_screenshot",
    "data-name": "Regional screenshot",
    transform: "translate(-3217 -7735)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(3217 7735)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_65609",
    "data-name": "Group 65609",
    transform: "translate(-35.009 23.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5825",
    "data-name": "Rectangle 5825",
    transform: "translate(3260.009 7719.081)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7,
    height: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34543",
    "data-name": "Path 34543",
    d: "M3685.5,7365.536v2.027h-2.237",
    transform: "translate(-426.282 350.613)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34544",
    "data-name": "Path 34544",
    d: "M2.237,0V2.027H0",
    transform: "translate(3257.186 7730.013) rotate(-90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34545",
    "data-name": "Path 34545",
    d: "M2.237,0V2.027H0",
    transform: "translate(3271.042 7729.804) rotate(-180)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34546",
    "data-name": "Path 34546",
    d: "M2.237,0V2.027H0",
    transform: "translate(3271.042 7716.149) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionalScreenshot);
export default __webpack_public_path__ + "static/media/RegionalScreenshot.d56ed8192b1f54f78743756605abed4f.svg";
export { ForwardRef as ReactComponent };